"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasErrorSelector = exports.getTaxPercentage = exports.getPrimaryDealerCode = exports.getPkgSlice = exports.getPhoneNumber = exports.getLoadingState = exports.getCurrentScreen = exports.getBundleDetails = exports.getAgentName = exports.fetchingBundleErrorSelector = exports.dateFormatSelector = void 0;
var _appConstants = require("../appConstants");
var getPkgSlice = function getPkgSlice(state) {
  return state[_appConstants.pkgName];
};
exports.getPkgSlice = getPkgSlice;
var getBundleDetails = function getBundleDetails(state) {
  var _getPkgSlice;
  return (_getPkgSlice = getPkgSlice(state)) === null || _getPkgSlice === void 0 ? void 0 : _getPkgSlice.bundleDetails;
};
exports.getBundleDetails = getBundleDetails;
var getLoadingState = function getLoadingState(state) {
  var _getPkgSlice2;
  return (_getPkgSlice2 = getPkgSlice(state)) === null || _getPkgSlice2 === void 0 ? void 0 : _getPkgSlice2.isLoading;
};
exports.getLoadingState = getLoadingState;
var hasErrorSelector = function hasErrorSelector(state) {
  var _getPkgSlice3;
  return (_getPkgSlice3 = getPkgSlice(state)) === null || _getPkgSlice3 === void 0 ? void 0 : _getPkgSlice3.hasError;
};
exports.hasErrorSelector = hasErrorSelector;
var fetchingBundleErrorSelector = function fetchingBundleErrorSelector(state) {
  var _getPkgSlice4;
  return (_getPkgSlice4 = getPkgSlice(state)) === null || _getPkgSlice4 === void 0 ? void 0 : _getPkgSlice4.fetchingBundleError;
};
exports.fetchingBundleErrorSelector = fetchingBundleErrorSelector;
var getCurrentScreen = function getCurrentScreen(state) {
  var _getPkgSlice5;
  return (_getPkgSlice5 = getPkgSlice(state)) === null || _getPkgSlice5 === void 0 ? void 0 : _getPkgSlice5.currentPurchaseModalScreen;
};
exports.getCurrentScreen = getCurrentScreen;
var getPhoneNumber = function getPhoneNumber(state) {
  var _state$props, _state$props$topupLis;
  return (_state$props = state.props) === null || _state$props === void 0 ? void 0 : (_state$props$topupLis = _state$props.topupList) === null || _state$props$topupLis === void 0 ? void 0 : _state$props$topupLis.phoneNumber;
};
exports.getPhoneNumber = getPhoneNumber;
var getPrimaryDealerCode = function getPrimaryDealerCode(state) {
  var _state$props2, _state$props2$storeDe;
  return (_state$props2 = state.props) === null || _state$props2 === void 0 ? void 0 : (_state$props2$storeDe = _state$props2.storeDetails) === null || _state$props2$storeDe === void 0 ? void 0 : _state$props2$storeDe.primaryDealerCode;
};
exports.getPrimaryDealerCode = getPrimaryDealerCode;
var getAgentName = function getAgentName(state) {
  var _state$authentication, _state$authentication2, _state$authentication3;
  return (_state$authentication = state.authentication) === null || _state$authentication === void 0 ? void 0 : (_state$authentication2 = _state$authentication.agentTokenDetails) === null || _state$authentication2 === void 0 ? void 0 : (_state$authentication3 = _state$authentication2.user_info) === null || _state$authentication3 === void 0 ? void 0 : _state$authentication3.sub;
};
exports.getAgentName = getAgentName;
var dateFormatSelector = function dateFormatSelector(state) {
  var _state$config, _state$config$data, _state$config$data$gl;
  return (_state$config = state.config) === null || _state$config === void 0 ? void 0 : (_state$config$data = _state$config.data) === null || _state$config$data === void 0 ? void 0 : (_state$config$data$gl = _state$config$data.global) === null || _state$config$data$gl === void 0 ? void 0 : _state$config$data$gl.dateFormat;
};
exports.dateFormatSelector = dateFormatSelector;
var getTaxPercentage = function getTaxPercentage(state, topupWidget) {
  var _state$config2, _state$config2$data, _state$config2$data$w;
  var topupConfig = state === null || state === void 0 ? void 0 : (_state$config2 = state.config) === null || _state$config2 === void 0 ? void 0 : (_state$config2$data = _state$config2.data) === null || _state$config2$data === void 0 ? void 0 : (_state$config2$data$w = _state$config2$data.widgets) === null || _state$config2$data$w === void 0 ? void 0 : _state$config2$data$w[topupWidget];
  if (topupConfig) {
    var insID = Object.keys(topupConfig)[0];
    return topupConfig[insID].tax;
  }
  return null;
};
exports.getTaxPercentage = getTaxPercentage;